module.exports = __webpack_public_path__ + "img/dec-2.d06d8627.png";